import { graphql } from 'gatsby';
import useActiveLink from '@/components/Link/hooks/useActiveLink';
import { IconWrapper, StyledIcon, StyledLink, StyledList, Wrapper } from './StickySidebar.styles';
import { type BlockHTMLId } from '@/utils/renderBlock';

const StickySidebar = ({
  stickySidebarElements: elements,
  system,
  id,
}: Queries.STICKY_SIDEBARFragment & BlockHTMLId) => {
  const activeLinkId = useActiveLink({
    links: elements.sticky_sidebar_items.value,
    linkExtractor: (item) => item.elements.link.value,
  })?.system.id;

  return (
    <Wrapper data-codename={system.codename} id={id}>
      <StyledList>
        {elements.sticky_sidebar_items.value.map((item) => {
          const icon = item.elements.icon.value;
          const link = item.elements.link.value;
          const isActive = activeLinkId === item.system.id;

          return (
            <li key={item.system.id}>
              <StyledLink {...link} isActive={isActive} aria-selected={isActive}>
                <IconWrapper>
                  <StyledIcon url={icon.url} />
                </IconWrapper>
              </StyledLink>
            </li>
          );
        })}
      </StyledList>
    </Wrapper>
  );
};

export const fragment = graphql`
  fragment STICKY_SIDEBAR on kontent_item_sticky_sidebar {
    stickySidebarElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      sticky_sidebar_items {
        value {
          elements {
            link {
              value {
                ...LINK
              }
            }
            icon {
              value {
                url
              }
            }
          }
          system {
            id
          }
        }
      }
    }
    system {
      codename
    }
  }
`;

export default StickySidebar;
